<template>
  <div class="shopping-mall" :class="languages">
    <!--头部区域-->
    <component :is="currentHeader" v-if="showHeader"/>
    <!--内容区域-->
    <router-view/>
    <!--底部区域-->
    <component :is="currentFooter" v-if="!fromListing"/>
    <!--入门指引弹窗-->
    <gettingStarted v-if="!fromListing" ref="gettingStarted"/>
    <!--定制商品设计重复异常提示-->
    <designRepetitionPromptModal/>
    <!--右侧固定快捷菜单组件-->
    <fixedRightNav source="shopping"/>
  </div>
</template>

<script>
import shopHeader from './header';
import shopFooter from './footer';
import gettingStarted from '@/components/common/gettingStarted';
import commonMixin from '@/components/mixin/common_mixin';
import {addLangStyle, getSetLanguages} from '@/utils/common';
import designRepetitionPromptModal from "@/components/common/designRepetitionPromptModal.vue";
import fixedRightNav from "@/components/common/fixedRightNav.vue";
import {bindAppScrollClosePoppers, unbindAppScrollClosePoppers} from "@/utils/bindAppScrollClosePoppers";
import trsFooter from "@/components/layout/shopping/trsFooter.vue";
import trsHeader from "@/components/layout/shopping/trsHeader.vue";

export default {
  name: 'shopmain',
  mixins: [commonMixin],
  components: {
    shopHeader,
    shopFooter,
    trsHeader,
    trsFooter,
    gettingStarted,
    designRepetitionPromptModal,
    fixedRightNav
  },
  data() {
    return {
      languages: ''
    };
  },
  async created() {
    await this.$loadProjectTheme();
    this.$webSocket.initWebSocket();
    this.languages = getSetLanguages();
    addLangStyle();
  },
  mounted() {
    this.$nextTick(() => {
      bindAppScrollClosePoppers({
        selector: '#app',
        useRaf: true
      });
    });
  },
  beforeDestroy() {
    unbindAppScrollClosePoppers();
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing;
    },
    isShopDetails() {
      return this.$route.path.includes('/shopDetails');
    },
    showHeader() {
      return !(this.fromListing && this.isShopDetails);
    },
    currentHeader() {
      return this.systemEnvironment === 'trs' ? 'trsHeader' : 'shopHeader';
    },
    currentFooter() {
      return this.systemEnvironment === 'trs' ? 'trsFooter' : 'shopFooter';
    }
  }
};
</script>

<style scoped>
</style>